import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import withExpandable from '@nerdwallet/react-with-expandable';
import { Text, Box } from '@nerdwallet/currency';
import './fly-out-header-expandable.less';

var FlyOutHeaderExpandable = function FlyOutHeaderExpandable(_ref) {
  var expanded = _ref.expanded,
      expandable = _ref.expandable,
      title = _ref.title,
      copy = _ref.copy;
  var bottomBorderStyle = expanded ? {
    borderBottom: '0px solid transparent',
    marginBottom: '0px'
  } : null;
  var key = "expandable-".concat(title);
  return /*#__PURE__*/React.createElement("div", {
    key: key
  }, /*#__PURE__*/React.createElement("div", {
    className: "fly-out-header__subnav",
    style: bottomBorderStyle
  }, /*#__PURE__*/React.createElement("button", _extends({}, expandable.toggle, {
    type: "button",
    className: "fly-out-header__subnav--btn"
  }), /*#__PURE__*/React.createElement(Box, {
    className: "fly-out-header__subnav--name"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, title)), expanded ? "\u2013" : '+')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("section", _extends({}, expandable.region, {
    className: classNames('expandable', {
      expanded: expanded,
      collapsed: !expanded
    })
  }), copy)));
};

FlyOutHeaderExpandable.displayName = 'FlyOutHeaderExpandable';
FlyOutHeaderExpandable.propTypes = _objectSpread({}, withExpandable.propTypes);
export default withExpandable(FlyOutHeaderExpandable);